import React, {useEffect, useState, useReducer, useRef } from 'react'
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

import MaterialTable from "material-table"
import { Paper } from "@material-ui/core"
import { Chip } from "@material-ui/core"
import { Grid } from '@material-ui/core'
import Fab from '@material-ui/core/Fab'

import Snackbar from '@material-ui/core/Snackbar'
import Alert from '@material-ui/lab/Alert'


import {green, red, blue, grey} from '@material-ui/core/colors'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { faSortUp } from "@fortawesome/free-solid-svg-icons"
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons'
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { faAngleDoubleLeft } from '@fortawesome/free-solid-svg-icons'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { faList } from '@fortawesome/free-solid-svg-icons'

import {_t} from '../../../i18n/lang'
import  { MaterialTableLocaleDelayed } from './../../../i18n/material-table'

import { projectPricesServices } from "../../../services/projectPricesServices"
// import { addProjectToCart } from "../cart/Actions"
import ListDetails from "./ListDetails"
import Filter from './Filter'
import Cart from '../cart/Cart'
import CartReducer from '../cart/Reducer'
import {cartConstants} from "../../../constants/cartConstants";

const tableIcons = {
    NextPage: React.forwardRef((props, ref) => <FontAwesomeIcon icon={faAngleRight} { ...props }  /> ),
    PreviousPage: React.forwardRef((props, ref) => <FontAwesomeIcon icon={faAngleLeft} { ...props } /> ),
    FirstPage: React.forwardRef((props, ref) => <FontAwesomeIcon icon={faAngleDoubleLeft} { ...props } /> ),
    LastPage: React.forwardRef( (props, ref) => <FontAwesomeIcon icon={faAngleDoubleRight} { ...props } /> ),
    Search: React.forwardRef((props, ref) => <FontAwesomeIcon icon={faSearch} { ...props } /> ),
    SortArrow: React.forwardRef((props, ref) => <FontAwesomeIcon { ...props } icon={faSortUp} /> ),
    ResetSearch: React.forwardRef((props, ref) => <FontAwesomeIcon icon={faTimes} { ...props } size='xs' /> ),
    Filter: React.forwardRef((props, ref) => <FontAwesomeIcon icon={faFilter} { ...props } /> ),
};


const useStyles = makeStyles((theme) => ({
    wrap: {
        flexGrow: 1,
        paddingRight: '1em',
        paddingLeft: '1em',
    },
    paper: {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
    },
    tableHeader: {
        color: 'rgba(0, 0, 0, .54)',
        marginBottom: '1em'
    },
    iconColor: {
        color: '#fff'
    },
    fabStyle: {
        marginRight: '1em',
        backgroundColor: '#cb0101'
    },
    headerColor: {
        color: '#cb0101',
    }
}));

const statusColor = (status) => {
    if (status === 'INACTIVE') {
        return red[500]
    }
    if (status === 'ACTIVE') {
        return green[500]
    }
    return 'blueGrey'
}

const cache = new Map()

export default function CanonProjects(props) {
    const [projectData, setProjectData] = useState([])
    const [eurExchangeRate, setEurExchangeRate] = useState(1)
    const [cart, setCart] = useReducer(CartReducer, {cart: new Map()})
    const [loading, setLoading] = useState(true)
    const [cartLoading, setCartLoading] = useState(false)
    const [buttonLoading, setButtonLoading] = useState(new Map())
    const [alert, setAlert] = useState({open: false, message: '', type: 'success', duration: 6000})
    const [detailsToReload, setDetailsToReload] = useState([])
    const [backFromOtherTab, setBackFromOtherTab] = useState(false)
    const tableRef = useRef()

    const { vendor } = useParams();

    const [filters, setFilters] = useState({
        phrase: '',
        startFrom: null,
        startTo: null,
        expireFrom: null,
        expireTo: null,
    })

    useEffect ( () => {

        if (backFromOtherTab) {
            let oldDetails = []

            projectData.forEach((project) => {
                if (typeof project.tableData.showDetailPanel !== 'undefined') {
                    oldDetails.push(project.id)
                }
            })

            tableRef.current.state.data = tableRef.current.state.data.map(data => {
                // remove previous render
                data.tableData = {
                    id: data.id
                }

                if (oldDetails.indexOf(data.id) > -1) {
                    data.tableData = {
                        ...data.tableData,
                        showDetailPanel: tableRef.current.props.detailPanel[0].render,
                    }
                }
                return data;
            });

        }
    }, [backFromOtherTab])

    useEffect( () => {
        const abortController = new AbortController()
        async function fetchData() {
            setLoading(true);
            const result = await projectPricesServices.projects(vendor, abortController)
            if (!result) {
                return
            }
            const { projects, eurExchangeRate } = result
            setProjectData(projects)
            setEurExchangeRate(eurExchangeRate)
            setLoading(false)
        }

        async function fetchCart() {
            setCartLoading(true)
            const response = await projectPricesServices.cart(abortController)
            if (!response) {
                setCartLoading(false)
                return
            }
            const contents = JSON.parse(response['content'])

            if (!contents) {
                setCartLoading(false)
                return
            }

            contents.forEach((content) => {
                const projectData = {
                    id: content.id,
                    projectId: content.projectId,
                    projectNumber: content.projectNumber,
                    projectCustomerId: content.projectCustomerId,
                    vendorId: content.vendorId,
                    vendor: content.vendor,
                    client: content.client,
                }

                addProjectToCart(projectData, content.details, content.features)
            })
            setCartLoading(false)
        }

        fetchData();
        fetchCart();

        document.addEventListener("visibilitychange", function() {
            if (document.hidden) {
                setBackFromOtherTab(true)
            }

            if (!document.hidden) {
                setBackFromOtherTab(false)
            }
        });
        return () => abortController.abort()
    }, [vendor])


    async function fetchDetailsData(projectId) {
        let details = []

        if (cache.has(projectId)) {
            details = cache.get(projectId)
            addProjectDetails(projectId, details)
            return details
        }

        setCartLoading(true)
        setButtonLoading(buttonLoading.set(projectId, true))
        let response  = await projectPricesServices.project(projectId)
        details =  response.details
        cache.set(projectId, details)
        addProjectDetails(projectId, details)
        setCartLoading(false)
        setButtonLoading(buttonLoading.set(projectId, false))

        return details
    }

    const showAlert = (type, message, duration = 6000) => {
        setAlert({
            open: true,
            message,
            type,
            duration
        })
    };

    const closeAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setAlert({
            open: false,
            message: '',
            type: 'success'
        })
    };


    const classes = useStyles();

    const styleCss = {
        fontSize: '10px'
    }

    const columns = [
        {
            title: _t('PROJECT_TABLE_HEAD_ID'),
            field: 'id',
            type: 'numeric',
            cellStyle: {textAlign: 'center'},
            headerStyle: {textAlign: 'center'},
        },
        {title: _t('PROJECT_TABLE_HEAD_NO'), field: 'projectNo'},
        {
            title: _t('PROJECT_TABLE_HEAD_STATUS'),
            field: 'status',
            cellStyle: {textAlign: 'center'},
            headerStyle: {
                textAlign: 'center',
            },
            render(rowData) {
               return <Chip
                   style={{backgroundColor: statusColor(rowData.status)}}
                   label={_t(`PROJECT_PRICES_STATUS_${rowData.status}`)}
                   size='small'
               />
            }
        },
        {
            title: _t('PROJECT_TABLE_HEAD_CUSTOMER'),
            field: 'client',
            render(rowData) {
                return <label style={styleCss}>{rowData.client}</label>
            }
        },
        {
            title: _t('CANON_PRODUCT_TABLE_HEAD_RESELLER'),
            field: 'resellerName',
            render(rowData) {
                return <div>
                    <label style={styleCss}>{rowData.resellerName}</label>
                    <label style={styleCss}><i>({rowData.resellerMfgId})</i></label>
                </div>
            }
        },
        {
            title: _t('PROJECT_TABLE_HEAD_START_AT'),
            field: 'startAt',
            type: 'date',
            cellStyle: {textAlign: 'right'},
            headerStyle: {textAlign: 'right'},
        },
        {
            title: _t('PROJECT_TABLE_HEAD_EXPIRE_AT'),
            field: 'expireAt',
            type: 'date',
            cellStyle: {textAlign: 'right'},
            headerStyle: {textAlign: 'right'},
        },
    ]

    const filterByPhrase = (row) => {
        const { projectNo, client, resellerName } = row
        return projectNo.toLowerCase().includes(filters.phrase.toLowerCase())
            || client.toLowerCase().includes(filters.phrase.toLowerCase())
            || resellerName.toLowerCase().includes(filters.phrase.toLowerCase())
    }

    const filterByStartFrom = (row) => {
        if (!filters.startFrom) {
            return row
        }

        const rowStartFrom = new Date(`${row.startAt}`)
        const { startFrom } = filters
        const filterStart = new Date(
            startFrom.getFullYear(),
            startFrom.getUTCMonth(),
            startFrom.getDate(),
            0,
            0,
            0
        )

        return rowStartFrom >= filterStart
    }

    const filterByStartTo = (row) => {
        if (!filters.startTo) {
            return row
        }

        const rowStartTo = new Date(`${row.startAt}`)
        const { startTo } = filters
        const filterStart = new Date(
            startTo.getFullYear(),
            startTo.getUTCMonth(),
            startTo.getDate(),
            23,
            59,
            59
        )

        return rowStartTo <= filterStart
    }

    const filterByExpireFrom = (row) => {

        if (!filters.expireFrom) {
            return row
        }

        const rowExpireFrom = new Date(`${row.expireAt}`)
        const { expireFrom } = filters
        const filterExpire = new Date(
            expireFrom.getFullYear(),
            expireFrom.getUTCMonth(),
            expireFrom.getDate(),
            0,
            0,
            0
        )

        return rowExpireFrom >= filterExpire
    }

    const filterByExpireTo = (row) => {
        if (!filters.expireTo) {
            return row
        }

        const rowExpireTo = new Date(`${row.expireAt}`)
        const { expireTo } = filters
        const filterExpire = new Date(
            expireTo.getFullYear(),
            expireTo.getUTCMonth(),
            expireTo.getDate(),
            23,
            59,
            59
        )

        return rowExpireTo <= filterExpire
    }

    const filteredData = projectData
        .filter(filterByPhrase)
        .filter(filterByStartFrom)
        .filter(filterByStartTo)
        .filter(filterByExpireFrom)
        .filter(filterByExpireTo)

    const addProjectToCart = (projectData, details, features) => {
        const payload = {
            ...projectData,
            details,
            features,
            fetchData: 1,
        }

        setCart({type: cartConstants.ADD, payload})
    }

    const removeProjectFromCart = (project) => {
        setCart({type: cartConstants.REMOVE, payload: project})
        updateCart()

        const projectIds = new Set([project.id]);
        removeProjectsFeaturesValues(projectIds)
    }

    const addProjectDetails = (id, details) => {
        setCart({type:  cartConstants.ADD_DETAILS, payload: {id, details}})
        updateCart()
    }

    const editProjectDetailQty = (id, part, qty, withoutUpdateCart = 0) => {
        setCart({type: cartConstants.EDIT_DETAIL, payload: {id, part, qty}})
        if (!withoutUpdateCart) {
            updateCart()
        }
    }

    const removeDetailFromProject = (id, part) => {
        setCart({type: cartConstants.REMOVE_DETAIL, payload: {id, part}})
        updateCart()
    }

    const editProjectDetailVendorIdentifier = (id, part, vendorIdentifier) => {
        setCart({type: cartConstants.EDIT_DETAIL_VENDOR_IDENTIFIER, payload: {id, part, vendorIdentifier}})
        updateCart()
    }

    const addDetail = (detail, features) => {
        setCart({type: cartConstants.ADD_DETAIL, payload: { detail, features }})
        updateCart()
    }

    const editProjectFeature = (id, feature) => {
        setCart({ type: cartConstants.EDIT_PROJECT_FEATURE, payload: { id, feature } });
        updateCart()
    }

    const resetCart =() => {
        setCart({type: 'clear'})
        updateCart()
    }


    const updateCart = async () => {
        if (!cart) {
            return
        }

        let temp = []
        for (const item of cart.cart.entries()) {
            temp.push(item[1])
        }

        await projectPricesServices.updateCart(temp)
    }

    const removeProjectsFeaturesValues = async (projectIds) => {
        const promises = [];

        projectIds.forEach(async (projectId) => {
            promises.push(projectPricesServices.removeProjectFeatureValues(projectId))
        })

        await Promise.all(promises)
    }

    const loadCart2AB = async () => {
        if (!cart) {
            return
        }
        setCartLoading(true)

        // zeby detale zostaly ponownie otwarte najpierw musimy je zamknac
        let openedDetails = []

        projectData.forEach((project) => {
            if (typeof project.tableData.showDetailPanel !== 'undefined') {
                openedDetails.push(project.id)
                delete project.tableData.showDetailPanel
            }
        })

        const result = await projectPricesServices.loadCart2AB(cart.cart.entries())
        resetCart()
        showAlert(result.type, result.message)

        // ustawiamy ktore detale maja zostac ponownie otwarte, po requescie
        setDetailsToReload(openedDetails)

        setCartLoading(false)
    }

    const productInCart = (projectId, part) => {
        if (!cart.cart.has(projectId)) {
            return false
        }
        const found = cart.cart.get(projectId).details.filter((row) => row.part === part)
        return found.length > 0
    }

    let alertBorderColor = '#28a745'

    if (alert.type === 'info') {
        alertBorderColor = '#2196f3'
    }

    if (alert.type === 'warning') {
        alertBorderColor = '#ff9800'
    }

    if (tableRef.current && filteredData.length) {
        const { detailPanel } = tableRef.current.props
        const foundedDetailIndexes = []

        detailsToReload.forEach((openedId) => {
            const rowIndex = filteredData.findIndex(item => item.id === openedId)
            foundedDetailIndexes.push(rowIndex)
        })

        if (foundedDetailIndexes.length) {
            foundedDetailIndexes.forEach((foundDetailIndex) => {
                if (filteredData[foundDetailIndex].tableData) {
                    filteredData[foundDetailIndex].tableData = {
                        ...filteredData[foundDetailIndex].tableData,
                        showDetailPanel: typeof detailPanel === 'function' ? detailPanel : detailPanel[0].render,
                    }
                }
            })
            setDetailsToReload([])
        }
    }

    const displayTitle = () => {
        return (
            <h1 className={ classes.headerColor } style={{ marginBottom: '1em', paddingLeft: '10px'}}>
                <Fab size="medium" aria-label="cart" className={classes.fabStyle}>
                    <FontAwesomeIcon icon={faList} className={classes.iconColor}/>
                </Fab>
                {_t("CANON_HEADER_PROJECT")}
            </h1>
        )
    }

    console.log('cart Loading: ', cartLoading);

    return (
        <div className={classes.wrap}>
            <Snackbar open={alert.open}
                      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                      autoHideDuration={6000}
                      onClose={closeAlert}
                      style={{border: `1px solid ${alertBorderColor}`}}
            >
                <Alert
                    onClose={closeAlert}
                    severity={alert.type}
                >
                    <div dangerouslySetInnerHTML={{__html: alert.message}} />
                </Alert>
            </Snackbar>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Paper className={classes.paper}>
                        <MaterialTable
                            tableRef={tableRef}
                            className={classes.root}
                            disableGutters={true}
                            columns={columns}
                            data={filteredData}
                            isLoading={loading}
                            title={displayTitle()}
                            localization={MaterialTableLocaleDelayed()}
                            options={{
                                showTitle: true,
                                search: true,
                                draggable: false,
                                actionsColumnIndex: -1,
                                detailPanelColumnAlignment: 'right',
                                pageSizeOptions: [5, 10, 20, 50, 100],
                                headerStyle: {
                                    backgroundColor: '#33323a',
                                    color: '#fff',
                                    '& span': {
                                        color: 'red'
                                    }
                                },

                            }}

                            icons={tableIcons}
                            detailPanel={[
                                {
                                    icon() { return <FontAwesomeIcon icon={faChevronDown} size='xs' /> },
                                    openIcon() { return <FontAwesomeIcon icon={faChevronUp} size='xs' /> },
                                    tooltip: _t('PROJECT_TABLE_SHOW_DETAILS'),
                                    render(rowData) {
                                        return (
                                            <ListDetails
                                                project={rowData}
                                                addDetail={addDetail}
                                                showAlert={showAlert}
                                                productInCart={productInCart}
                                            />
                                        )
                                    },
                                }
                            ]}

                        />
                    </Paper>
                </Grid>
                <Grid item xs={5}>
                    <Paper className={classes.paper} style={{
                        minHeight: '12em',
                        position: "relative",
                        paddingBottom: '3em'
                    }}>
                        <Cart
                            cart={cart.cart}
                            removeProjectFromCart={removeProjectFromCart}
                            loadCart2AB={loadCart2AB}
                            isLoading={cartLoading}
                            addProjectDetails={addProjectDetails}
                            editProjectDetailQty={editProjectDetailQty}
                            removeDetailFromProject={removeDetailFromProject}
                            editProjectDetailVendorIdentifier={editProjectDetailVendorIdentifier}
                            editProjectFeature={editProjectFeature}
                            eurExchangeRate={eurExchangeRate}
                        />
                    </Paper>
                </Grid>
            </Grid>
        </div>
    )
}
